import React from 'react';
import { makeStyles, createStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {fontSizes,fontFamily,colors} from '../../styles/variables';
// import RadioButtonsGroup from '../RadioButtonGroup/RadioButtonGroup';
// import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(() => 

  createStyles({
    container:{
        // margin:0,
        marginRight:60,
        display:'flex',
        justifyContent:'center',
        marginTop:'5rem',
        '&.MuiGrid-spacing-xs-10 > .MuiGrid-item':{
            padding:80
        },
        '@media only screen and (max-width: 959px)': {
            marginRight:0,
            marginTop:'3rem',
            marginBottom:'1rem',
          },
    },
    paper: {
        height: 290,
        width: 279,
        borderRadius:19,
        boxShadow:'none',
        paddingBottom:10,
       
    },
    cardHeading:{
        height:'30%',
        backgroundColor:colors.darkGray,
        borderTopLeftRadius:19,
        borderTopRightRadius:19
    },
    cardHeadingPink:{
        height:'30%',
        backgroundColor:colors.red,
        borderTopLeftRadius:19,
        borderTopRightRadius:19
    },
    pricingCard: {
        height: 580,
        width: 275,
        // borderTopWidth:20,
        // borderTopColor:'#414141',
        // borderTopStyle:'solid',
        borderRadius:19,
        boxShadow:'0px 0px 40px #0C207219',
        paddingBottom:10,
        // marginBottom:'10%',
        marginLeft:'5%'
    },
    pricingCardPink: {
        // height: 360,
        width: 275,
        // borderTopWidth:20,
        // borderTopColor:colors.red,
        // borderTopStyle:'solid',
        borderRadius:19,
        boxShadow:'0px 0px 40px #0C207219',
        paddingBottom:10,
        marginBottom:'10%',
        marginLeft:'5%'
    },
    pricingHeading:{
        fontFamily:fontFamily.poppins,
        fontSize: fontSizes.md.large,
        fontWeight:'bolder',
        textAlign:'center',
        color: colors.white,
        paddingTop:40,
    },
    pricingHeadingPink:{
        fontFamily:fontFamily.poppins,
        fontSize:fontSizes.md.large,
        fontWeight:'bolder',
        textAlign:'center',
        color:colors.white,
        paddingTop:40,
    },
    pricingDescription:{
        fontFamily:"inherit",
        fontSize:fontSizes.md.small,
        fontWeight:'normal',
        textAlign:'center',
        color: colors.white,
        lineHeight: 2,
        paddingTop:5,
        paddingLeft:20,
        paddingRight:20,
        overflow:'hidden',
        height:70
    },
    submitButton:{
        color: '#fff',
        background: 'linear-gradient(98deg, #414141 0%, #525252 100%)',
        borderRadius: 37,
        padding: '1% 9%',
        textTransform: 'uppercase',
    },
    submitButtonDiv:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        alignContent:'center',
        padding:25
    },
    radioButtonGroup:{
        display:'flex',
        justifyContent:'center',
        textAlign:'center',
    },
    priceMainDiv:{
        display:'flex',
        justifyContent:'center',
        alignContent:'center',
        alignItems:'center',
        paddingTop:'3em'
    },
    price:{
        fontWeight:'bold',
        textAlign:'center'
    },
    pricePink:{
        fontWeight:'bold',
        textAlign:'center',
        color:colors.red
    }
  }),
);

export default function PricingPage(props: any) {
  const classes = useStyles();
  return (
    <Grid item spacing={2} className={classes.container}>
        <Paper className={clsx(classes.pricingCard, [props.heading2?classes.pricingCardPink : ''])}>
            <div className={clsx(classes.cardHeading, [props.heading2?classes.cardHeadingPink : ''])} >
            <div className={clsx(classes.pricingHeading, [props.heading2?classes.pricingHeadingPink : ''])}>{[props.heading1,props.heading2]}</div>
           <div className={classes.pricingDescription}>{props.description}</div>
           </div>
           <div className={classes.priceMainDiv}>
                <Typography variant="h3" component="h3" className={clsx(classes.price,[props.price2?classes.pricePink : ''])}>
                    {[props.price1,props.price2]}
                </Typography>
           </div>
            
          
             {props.children}
        </Paper>
    </Grid>  
  );
}
